import type { ReactNode } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useIsAuthenticated } from '@web/features/auth/utils/tokenStorage'
import { LoginPage } from './pages/LoginPage'
import { OrgPickerPage } from './pages/OrgPickerPage'
import { OrgLayout } from './components/OrgLayout'
import { DashboardPage } from './pages/DashboardPage'
import { FichePage } from './pages/FichePage'
import { LieuxPage } from './pages/LieuxPage'
import { LieuEditPage } from './pages/LieuEditPage'
import { CartePage } from './pages/CartePage'
import { AvisPage } from './pages/AvisPage'
import { PhotosPage } from './pages/PhotosPage'
import { EquipementsPage } from './pages/EquipementsPage'
import { ParcoursPage } from './pages/ParcoursPage'
import { TarifsPage } from './pages/TarifsPage'
import { AccesClientelePage } from './pages/AccesClientelePage'
import { useKeepSession } from './auth/keepSession'

function RequireAuth({ children }: { children: ReactNode }) {
  const authed = useIsAuthenticated()
  const location = useLocation()
  if (!authed) {
    return <Navigate to="/connexion" replace state={{ from: `${location.pathname}${location.search}` }} />
  }
  return <>{children}</>
}

export function App() {
  useKeepSession()
  return (
    <Routes>
      <Route path="/connexion" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <OrgPickerPage />
          </RequireAuth>
        }
      />
      <Route
        path="/o/:orgId"
        element={
          <RequireAuth>
            <OrgLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="fiche" element={<FichePage />} />
        <Route path="lieux" element={<LieuxPage />} />
        <Route path="lieux/nouveau" element={<LieuEditPage />} />
        <Route path="lieux/:type/:locationId" element={<LieuEditPage />} />
        <Route path="equipements" element={<EquipementsPage />} />
        <Route path="tarifs" element={<TarifsPage />} />
        <Route path="carte" element={<CartePage />} />
        <Route path="sentiers" element={<ParcoursPage />} />
        <Route path="acces" element={<AccesClientelePage />} />
        <Route path="avis" element={<AvisPage />} />
        <Route path="photos" element={<PhotosPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
